import React from 'react'
import PropTypes from 'prop-types'
import I18n from 'i18n'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MFA_SETUP_LOCATION } from '../MfaEnrolment'

const MfaEnrolmentNotice = ({ title, description, showSetupLink, className, testId }) => (
  <div className={`timeline-card mfa-enrolment-notice ${className}`.trim()} data-testid={testId} role='alert'>
    <div className='mfa-enrolment-notice__icon'>
      <FontAwesomeIcon icon='exclamation-triangle' size='2x' />
    </div>
    <div className='mfa-enrolment-notice__body'>
      <h2 className='text-l text-heavy mfa-enrolment-notice__title'>{title}</h2>
      <p className='mfa-enrolment-notice__description'>{description}</p>
      {showSetupLink &&
        <div className='mfa-enrolment-notice__actions'>
          <Link
            to={MFA_SETUP_LOCATION}
            className='waves-effect waves-light text-primary-color background-primary button-primary button-autowidth text-background-color'
            data-testid={`${testId}-cta`}
          >
            {I18n.t('components.2fa.enrolment.cta')}
          </Link>
        </div>}
    </div>
  </div>
)

MfaEnrolmentNotice.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  showSetupLink: PropTypes.bool,
  className: PropTypes.string,
  testId: PropTypes.string
}

MfaEnrolmentNotice.defaultProps = {
  showSetupLink: true,
  className: '',
  testId: 'mfa-enrolment-notice'
}

export default MfaEnrolmentNotice
